<template>
  <v-app>
    <router-view  />
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    itemsToken: undefined
  }),
  async created() {
    this.setInterval();
  //   const { path } = this.$route.fullPath;
  //   const manage = this.$route.fullPath.includes('manage');
  //   this.itemsToken = sessionStorage.access_token
  //   if (this.itemsToken === undefined && !manage) {
  //     if (path === "/") {
  //       return
  //     } else {
  //     this.$router.push("/");
  //   }
  // }
  },
  
  methods: {
    setInterval() {
      if (!this.$socket.connected) {
        this.$socket.connect();
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Sarabun&display=swap");

#app {
  font-family: "Sarabun" !important;
  /* background-color: #EBF7F7; */
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  font-size: 18px !important;
  /* margin-top: 30px;
  margin-bottom: 20px; */
  /* padding-top: 10px;
  padding-bottom: 10px; */
}

/* ==== style for scroll bar === */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #eff6fc;
  border-radius: 2px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #aaaaaa;
  border-radius: 6px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(134, 133, 133);
}

/* corner when both horizontal and vertical scrollbars meet */
::-webkit-scrollbar-corner {
  background: #d8d8d8;
}
/* ======================================= */

.v-messages__message {
  line-height: 20px !important;
}
</style>
